import { useState } from 'react';
import { videoThumbUrl, type Video } from '../api/client.ts';
import { formatDateShort, formatDuration } from '../lib/format.ts';
import './VideoCard.css';

export function VideoCard({ video, onOpen }: { video: Video; onOpen: () => void }) {
  // Falls back to the handoff's gradient placeholder when no frame was captured
  // (or the thumb request 404s).
  const [thumbFailed, setThumbFailed] = useState(false);
  const showThumb = video.hasThumb && !thumbFailed;

  return (
    <button type="button" className="video-card" onClick={onOpen}>
      <div className="video-card__thumb">
        {showThumb ? (
          <img src={videoThumbUrl(video.id)} alt="" loading="lazy" onError={() => setThumbFailed(true)} />
        ) : (
          <span aria-hidden="true">🎥</span>
        )}
      </div>
      <div className="video-card__footer">
        <div>
          <div className="video-card__title">{video.title}</div>
          <div className="video-card__duration">{formatDuration(video.durationSec)}</div>
        </div>
        <div className="video-card__date">{formatDateShort(video.tripDate)}</div>
      </div>
    </button>
  );
}
